.ControlGroup__container {
  display: flex;
  flex-direction: column;
  gap: var(--base-size-8);
  font-family: var(--brand-body-fontFamily);
  font-size: var(--brand-text-size-100);
  border: none;
  margin: 0;
  padding: 0;
}

.ControlGroup__label {
  margin: 0;
  padding: 0;
  margin-block-end: var(--base-size-8);
}

.ControlGroup__validation {
  display: flex;
  gap: var(--base-size-4);
  font-weight: var(--base-text-weight-medium);
  align-items: center;
}

.ControlGroup__validation--success {
  color: var(--brand-color-text-emphasized);
}

.ControlGroup__validation--error {
  color: var(--brand-color-danger-fg);
}

.ControlGroup__validation-icon--success {
  display: flex;
}

.ControlGroup__validation-icon--error {
  display: flex;
}

.ControlGroup__validation--animate-in {
  animation: 170ms ControlGroupValidationFadeIn var(--brand-animation-easing-glide);
}

.ControlGroup__container label {
  font-weight: var(--base-text-weight-medium);
}

@keyframes ControlGroupValidationFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
